import template from './comment-modal-preview.pug';

export const CommentModalPreviewModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class CommentModalPreviewModalComponent {
    constructor($rootScope) {
      'ngInject';
      this.$rootScope = $rootScope;
    }

    $onInit() {
    }

    close() {
      this.modalInstance.close(void(0));
    }

    destroy() {
      this.$rootScope.$broadcast('ChronologyList.Reload');
      this.modalInstance.close(void(0));
    }

  }
};
